// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-windowfooter_container__33txm","start":"idt-windowfooter_start__2soyc","between":"idt-windowfooter_between__1zxb2","end":"idt-windowfooter_end__1gzad"};